import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {Ad} from "../../interfaces/ad";
import {ApiService} from "../../services/api.service";
import {clearLastSeen, getLastSeen, setLastSeen} from "../../utils/sessionStorage";
import {CursorToken} from "../../interfaces/utils";
import {SmartAdType} from "../../interfaces/smartAd";
import { DefaultFrameComponent } from '../../frames/default-frame/default-frame.component';
import { KazSearchComponent } from '../../components/kaz-search/kaz-search.component';
import { KazSlideMenuComponent } from '../../components/kaz-slide-menu/kaz-slide-menu.component';
import { KazCardLastSeenComponent } from '../../components/kaz-card-last-seen/kaz-card-last-seen.component';
import { KazCardRecommendedComponent } from '../../components/kaz-card-recommended/kaz-card-recommended.component';
import { SmartEntryComponent } from '../../components/smart-entry/smart-entry.component';
import { KazButtonComponent } from '../../components/kaz-button/kaz-button.component';

@Component({
    selector: 'kaz-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent, KazSearchComponent, KazSlideMenuComponent, KazCardLastSeenComponent, KazCardRecommendedComponent, SmartEntryComponent, KazButtonComponent]
})
export class MainComponent implements OnInit {
  private _api = inject(ApiService);

  protected readonly SmartAdType = SmartAdType;

  lastSeenIds: string[] = [];
  lastSeen: Ad[] = [];
  recommended: Ad[] = [];

  adsPageSize: number = 21;
  nextToken: CursorToken = "@start";
  loadingAds: boolean = false;

  async ngOnInit() {
    await this.getAdList();
    await this.getLastSeen();
  }

  async getAdList() {
    try {
      this.loadingAds = true;
      const data = await this._api.getAdList('@start', this.adsPageSize);
      this.recommended = data.ads;
      this.nextToken = data.nextPageToken;
    } catch (err) {
      console.error(err);
    } finally {
      this.loadingAds = false;
    }
  }

  async loadMoreRecommends() {
    try {
      this.loadingAds = true;
      const data = await this._api.getAdList(this.nextToken, this.adsPageSize);
      this.recommended = [...this.recommended, ...data.ads];
      this.nextToken = data.nextPageToken;
    } catch (err) {
      console.error(err);
    } finally {
      this.loadingAds = false;
    }
  }

  async getLastSeen() {
    this.lastSeenIds = getLastSeen();
    try {
      if (this.lastSeenIds.length > 0) {
        const lastSeenIdsString = this.lastSeenIds.join(',');
        this.lastSeen = await this._api.getLastSeen(lastSeenIdsString);
        clearLastSeen();
        this.lastSeen.forEach( item => {
          setLastSeen(item.id);
        })
      }
    } catch (err) {
      console.error(err);
    }
  }

  hasValidatedAd(): boolean {
    return this.lastSeen.some((item) => item.validated && !item.reserved);
  }

}
